import {IconButton} from "@mui/material";
import React from "react";
import {Colors} from "../colors";
import {IconCloseDrawer} from "../assets";
import {SxProps} from "@mui/system";

interface ICloseDialogButton {
  onClose: () => void;
  color?: boolean;
  sx?: SxProps;
}

export const CloseDialogButton = ({onClose, color, sx}: ICloseDialogButton) => {
  return (
    <IconButton
      aria-label="close"
      size="small"
      onClick={onClose}
      sx={{
        position: "absolute",
        right: 8,
        top: 8,
        zIndex: 10,
        ...sx,
      }}
    >
      <IconCloseDrawer width={24} height={24} color={color ? Colors.bw.white : Colors.bw.black} />
    </IconButton>
  );
};
